
import React, { useEffect, useState } from "react";
import ContentEditorModal from "../ContentEditorModal";

export default function AdminContentManager() {
  const [contents, setContents] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    const res = await fetch("/api/content/list", { credentials: "include" });
    const data = await res.json();
    setContents(data);
  };

  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this content?")) return;

    const res = await fetch(`/api/content/${id}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (res.ok) {
      setContents(prev => prev.filter(c => c.id !== id));
    }
  };

  return (
    <>
      <h3>Content Manager</h3>

      <button
        className="btn btn-success mb-3"
        onClick={() => setEditing({})}
      >
        ➕ Add Content
      </button>

      <table className="table table-striped">
        <thead>
          <tr>
            <th>ID</th>
            <th>Page</th>
            <th>Section Type</th>
            <th>Unique ID</th>
            <th>Actions</th>
          </tr>
        </thead>

      <tbody>
  {contents.map((c, index) => (
    <tr key={c.id ?? `content-${index}`}>
      <td>{c.id}</td>
      <td>{c.page}</td>
      <td>{c.section_type}</td>
      <td>{c.unique_id}</td>
      <td>
        <button
          className="btn btn-sm btn-primary me-2"
          onClick={() => setEditing(c)}
        >
          Edit
        </button>
        <button
          className="btn btn-sm btn-danger"
          onClick={() => remove(c.id)}
        >
          Delete
        </button>
      </td>
    </tr>
  ))}
</tbody>
      </table>

      {editing && (
        <ContentEditorModal
          content={editing}
          onClose={() => setEditing(null)}
          onSaved={load}
        />
      )}
    </>
  );
}
